module.exports = __webpack_public_path__ + "img/step42.cf64b6cb.png";